<div class="adv-1" >
    <div class="row">
        <div class="col-sm-8">
            <img src="https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/rsz_credlix_white_logo.png" alt="">
            <h3>Ready to Take Your Business to the Next level ?</h3>
            <p class="text-white">Get Hassle free financing for your business</p>
        </div>
        <div class="col-sm-4 d-flex align-items-center justify-content-end">
            <a class="know-more-btn" href="https://www.credlix.com/" target="_blank">
                <span > KNOW MORE </span>
            </a>
        </div>
    </div>
</div>